import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { StyledInput } from "../ui/StyledInput";
import toast from "react-hot-toast";
import { useServiceDrawer } from "../features/returns/useServiceDrawer";
import { scheduleReturns } from "../features/returns/returnApi";
import { StyledButton } from "../ui/StyledButton";
import { useSearchParams } from "react-router-dom";

import { useMessageDialog } from "../../context/MessageDialogContext";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  p: 4,
  minHeight: "300px",
  borderRadius: "6px",
};

const ReturnsScheduleModal = () => {
  //     open,
  //     handleClose,
  // }: {
  //     open: boolean;
  //     handleClose: () => void;
  // }) => {
  const [date, setDate] = useState<string>("");
  const [searchParams, setSearchParams] = useSearchParams();

  const { showMessage } = useMessageDialog();

  const {
    isCancelReturnsOpen,
    isScheduleReturnsOpen,
    syncReturns,
    setSyncReturns,
    id,
    onCloseSchedule,
  } = useServiceDrawer();

  const addReturnsScheduleHandler = () => {
    scheduleReturns([
      {
        id: id
          ? parseInt(id as string)
          : parseInt(searchParams.get("returnId") as string),
        pickup_date: formatDate(new Date(date)),
      },
    ])
      .then((data) => {

        if (data?.data?.data[0].error === false) {
          showMessage("Success","Returns Scheduled successfully!");
        } else {
          showMessage("Error",data?.data?.data?.[0]?.message);
        }

        searchParams.delete("returnId");
        setSearchParams(searchParams);
        onCloseSchedule();
        setSyncReturns();
      })
      .catch((err) => console.log(err));
  };

  const handleDateChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setDate(event.target.value);
  };

  const formatDate = (currentDate: Date) => {
    const formattedDate = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(
      2,
      "0"
    )} ${String(currentDate.getHours()).padStart(2, "0")}:${String(
      currentDate.getMinutes()
    ).padStart(2, "0")}:${String(currentDate.getSeconds()).padStart(2, "0")}`;
    return formattedDate;
  };

  const doItLaterHandler = () => {
    setSyncReturns();
    onCloseSchedule();
  };

  return (
    <Modal open={isScheduleReturnsOpen} onClose={() => onCloseSchedule("")}>
      <Box sx={style}>
        <Stack
          justifyContent={"space-between"}
          direction={"column"}
          sx={{
            minHeight: "240px",
          }}
        >
          <div>
            <Typography variant="h6" component="h2" marginBottom={"20px"}>
              Schedule Pickup Your Returns
            </Typography>

            <StyledInput
              onChange={handleDateChange}
              type="datetime-local"
              fullWidth
            />
          </div>

          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"8px"}
          >
            <StyledButton
              fullWidth
              onClick={doItLaterHandler}
              variant="outlined"
            >
              Do it Later
            </StyledButton>
            <StyledButton
              onClick={addReturnsScheduleHandler}
              variant="contained"
            >
              Schedule
            </StyledButton>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ReturnsScheduleModal;
